<template>
  <v-container fluid class="pa-0 ma-8">
    <!-- {{ users[0] }} -->
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="users"
      :sort-by="[{ key: 'name', order: 'asc' }]"
      class="elevation-3 rounded-lg"
    >
      <template v-slot:no-data>
        <h3>No data available</h3>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>المستخدمون</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <DialogUser
            :item="item"
            :saveFunction="save"
            mode="add"
            iconName="mdi-plus"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <DialogUser
            :item="item"
            :saveFunction="save"
            mode="edit"
            iconName="mdi-account-edit"
          />

          <DialogSimp
            :v-model="dialogSimp"
            iconName="mdi-delete"
            :item="item"
            :confirmFunction="deleteItem"
            :message="messages.delete"
          />

          <!-- <DialogSimp
            v-if="item.status == 'blocked'"
            :v-model="dialogSimp"
            iconName="mdi-check-all"
            :item="item"
            :confirmFunction="activateItem"
            :message="messages.activate"
          />
          <DialogSimp
            v-if="item.status == 'active'"
            :v-model="dialogSimp"
            iconName="mdi-check"
            :item="item"
            :confirmFunction="deactivateItem"
            :message="messages.deactivate"
          /> -->
        </v-row>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-container>
          <p>{{ $t(`${item.status}`) }}</p>
        </v-container>
      </template>
    </v-data-table>
  </v-container>
  <overlay-loader v-model="loading" />
</template>
<script>
import DialogUser from "@/components/dialogs/DialogUser.vue";
import DialogSimp from "@/components/DialogSimp.vue";

import repo from "@/store/repo.js";
import swalFun from "@/plugins/swalFun";
import OverlayLoader from "@/components/common/OverlayLoader.vue";

export default {
  components: {
    DialogUser,
    DialogSimp,
    OverlayLoader,
  },
  data: () => ({
    loading: false,
    headers: [
      { title: "الاسم", key: "fullname" },
      { title: "الجوال", key: "phone" },
      { title: "البريد الالكتروني", key: "email" },
      { title: "الأدوار", key: "rolesNames" },
      { title: "الحالة", key: "status" },
      { title: "العمليات", key: "actions" },
    ],
    dialog: false,
    dialogSimp: false,
    editedIndex: -1,
    messages: {
      delete: "هل أنت متأكد",
      activate: "هل أنت متأكد",
      deactivate: "هل أنت متأكد",
    },
  }),
  computed: {
    users() {
      let us = repo.users.getAllUsers();
      for (let i = 0; i < us.length; i++) {
        us[i].rolesNames = us[i].roles.map((role) => role.rolename);
        us[i].rolesNames = us[i].rolesNames.join(", ");
      }
      return us;
    },
  },
  methods: {
    async fetch() {
      this.loading = true;
      const res = await repo.users.fetchAll();
      if (res) {
        //swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
      this.loading = false;
    },
    async save(formData, mode) {
      if (mode == "add") {
        //create a user
        formData.username = formData.fullname;
        //formData.roles = [...Object.values(formData.rolesNames)];
        console.log("form", mode, formData);
        const res = await repo.users.add(formData);
        if (res) {
          swalFun.success("success");
        } else {
          swalFun.fail("error");
        }
      } else {
        //update a user
        formData.username = formData.fullname;
        console.log("form", mode, formData);
        const res = await repo.users.update(formData);
        if (res) {
          swalFun.success("success");
        } else {
          swalFun.fail("error");
        }
      }
    },
    async deleteItem(item) {
      const res = await repo.users.delete(item.id);
      if (res) {
        swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
      //console.log("item to delete:", item.id);
    },
    activateItem(item) {
      console.log("item to activate:", item);
    },
    deactivateItem(item) {
      console.log("item to deactivate:", item);
    },
  },
  async mounted() {
    await this.fetch();
  },
};
</script>
